import ErrorCdMsgConstants from '../constants/error-cd-msg.constants'
const state = {
  /** グローバル成功メッセージリスト。 */
  _successMessages: [],
  /** グローバルエラーメッセージリスト。 */
  _errorMessages: []
}
const actions = {
  addToSuccessMessageList({ commit }, message) {
    // 切断メッセージが表示されている場合、新しいメッセージをリストに追加しない
    const isDisplayingDisconnectionMsg = state._errorMessages.some(msg => ErrorCdMsgConstants.SERVER_DISCONNECTION_ERR_CD_LIST.some(errCd => msg.includes(errCd)))
    if (isDisplayingDisconnectionMsg) {
      return
    }
    commit('removeAllErrorMessages')
    commit('removeAllSuccessMessages')
    commit('setSuccessMessage', message)
  },
  addToErrorMessageList({ commit }, message) {
    // 切断メッセージが表示されている場合、新しいメッセージをリストに追加しない
    const notNewDisconnectionMsg = ErrorCdMsgConstants.SERVER_DISCONNECTION_ERR_CD_LIST.every(errCd => !message.includes(errCd))
    const isDisplayingDisconnectionMsg = state._errorMessages.some(msg => ErrorCdMsgConstants.SERVER_DISCONNECTION_ERR_CD_LIST.some(errCd => msg.includes(errCd)))
    if (notNewDisconnectionMsg && isDisplayingDisconnectionMsg) {
      return
    }
    commit('removeAllErrorMessages')
    commit('setErrorMessage', message)
  },
  removeMessageFromSuccessList({ commit }, message) {
    commit('removeSuccessMessage', message)
  },
  removeMessageFromErrorList({ commit }, message) {
    commit('removeErrorMessage', message)
  },
  removeAllErrorMessages({ commit }) {
    commit('removeAllErrorMessages')
  },
  removeAllSuccessMessages({ commit }) {
    commit('removeAllSuccessMessages')
  },
  removeAllMessages({ commit }) {
    commit('removeAllErrorMessages')
    commit('removeAllSuccessMessages')
  },
  removeDisconnectionErrorMessage({ commit }) {
    commit('removeDisconnectionMessage')
  }
}

const mutations = {
  setSuccessMessage(state, message) {
    state._successMessages.push(message)
  },
  setErrorMessage(state, message) {
    state._errorMessages.push(message)
  },
  removeSuccessMessage(state, message) {
    const foundIndex = state._successMessages.indexOf(message)
    if (foundIndex !== -1) {
      state._successMessages.splice(foundIndex, 1)
    }
  },
  removeErrorMessage(state, message) {
    const foundIndex = state._errorMessages.indexOf(message)
    if (foundIndex !== -1) {
      state._errorMessages.splice(foundIndex, 1)
    }
  },
  removeAllErrorMessages(state) {
    state._errorMessages = []
  },
  removeAllSuccessMessages(state) {
    state._successMessages = []
  },
  removeDisconnectionMessage(state) {
    const disconnectiontMsgIndex = state._errorMessages.findIndex(msg => ErrorCdMsgConstants.SERVER_DISCONNECTION_ERR_CD_LIST.some(errCd => msg.includes(errCd)))
    if (disconnectiontMsgIndex !== -1) {
      state._errorMessages.splice(disconnectiontMsgIndex, 1)
    }
  }
}
// GETTERS
const getters = {
  errorMessageArray() {
    return state._errorMessages
  },
  successMessageArray() {
    return state._successMessages
  }
}
export const flashMessage = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/_store/flash.module.js